module.exports = __webpack_public_path__ + "images/facade-plan-1-6332b7a47e0d798c62f63746badff44b.jpg";